import {
  useState,
  useEffect,
  useContext,
  SetStateAction,
  Dispatch,
} from 'react'
import dynamic from 'next/dynamic'
import { InsuranceProviderContext } from 'context/common/InsuranceProvider'
import { filterTitle, sessionStorageKeys } from 'constants/common'
import HeaderFilterButton from 'app/SeFriendly/SeFriendlyProviderSearch/HeaderFilterButton'
import styles from './index.module.scss'
import { ProviderHeaderFilterTypes } from 'dataSource/ProviderSearch'

const InsuranceSelectionDropdown = dynamic(
  () =>
    import(
      'app/SeFriendly/SeFriendlyProviderSearch/InsuranceFilter/InsuranceSelectionDropdown/'
    )
)

type InsuranceFilterProps = {
  onFilterSelect: (selectedFilter: Record<string, string>) => void
  containerClassName?: string
  setAllInsurances: Dispatch<SetStateAction<InsuranceProvider[]>>
}

const InsuranceFilter: React.FC<InsuranceFilterProps> = ({
  onFilterSelect,
  containerClassName = '',
  setAllInsurances,
}) => {
  const [showInsuranceDropdown, setShowInsuranceDropdown] = useState<boolean>(
    false
  )
  const [insuranceDisplayValue, setInsuranceDisplayValue] = useState<string>('')
  const insuranceProviderContext = useContext(InsuranceProviderContext)

  useEffect(() => {
    const { insuranceDisplayValue } = insuranceProviderContext

    setInsuranceDisplayValue(insuranceDisplayValue)
  }, [insuranceProviderContext.insuranceDisplayValue])

  const onSelect = (insuranceProvider: InsuranceProvider, selfPay: boolean) => {
    if (selfPay) {
      sessionStorage.removeItem(sessionStorageKeys.INSURANCE_PROVIDER_NAME)
      setInsuranceDisplayValue('')
      onFilterSelect({
        insuranceId: null,
      })
    } else {
      const insuranceDisplayValue = insuranceProvider?.name || ''

      setInsuranceDisplayValue(insuranceDisplayValue)
      sessionStorage.setItem(
        sessionStorageKeys.INSURANCE_PROVIDER_NAME,
        insuranceDisplayValue
      )

      onFilterSelect({
        insuranceId: insuranceProvider?.id,
      })
    }
  }

  return (
    <HeaderFilterButton
      title={filterTitle.INSURANCE}
      showDropdown={showInsuranceDropdown}
      setShowDropdown={setShowInsuranceDropdown}
      filterType={ProviderHeaderFilterTypes.INSURANCE}
      containerClassName={containerClassName}
      buttonClassName={[
        styles.insurance_filter_button,
        'form-search insurance',
      ]}
      text={insuranceDisplayValue}
      placeHolder="My insurance is..."
      mobilePlaceHolder={filterTitle.INSURANCE}
      type="insurance"
    >
      <InsuranceSelectionDropdown
        insuranceDisplayValue={insuranceDisplayValue}
        closeDropdown={() => setShowInsuranceDropdown(false)}
        onSelect={onSelect}
        dropdownClass="top-6 mt-5"
        setAllInsurances={setAllInsurances}
        isSefriendly={true}
      />
    </HeaderFilterButton>
  )
}

export default InsuranceFilter
